import { render, staticRenderFns } from "./ques8_1.vue?vue&type=template&id=6b5b6b52"
import script from "./ques8_1.vue?vue&type=script&lang=js"
export * from "./ques8_1.vue?vue&type=script&lang=js"
import style0 from "./ques8_1.vue?vue&type=style&index=0&id=6b5b6b52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports